import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FORMS } from '../forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ngx-forums',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./forums.component.scss']
})
export class ForumsComponent extends BaseComponentConfig implements OnInit {
  breadCrumbs:BreadCrumbData[];
  options:ConfigOptions = {
    name:"Name",
    title:"Forums",
    idFieldName:"contentId",
    lookUpEndPoint:"LookupContent",
    searchResults:null,
    listForm:new OfbizList({
      fieldFormName:"FindContent",
      fieldFormLocation:"local",
      fieldFormFields:this.getFields("FindContent",FORMS),
      listFormName:"ListForumGroupsRest",
      entityName:"Content",
      listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
      columnFields:this.getFields("ListForumGroupsRest",FORMS),
      endPoint:"listFindContent",
      emptyListMessage:"",
      viewIndex:1,
      labelColumn:"contentName",
      actions:{
        position:'right',
        custom:[
          {
            name:'linkedList',
            title:'<i class="nb-folder-outline" title="Linked List"></i>'
          }
        ],
        delete:false,
      },
    }),
    addForm:new OfbizForm({
      local:true,
      formName:"AddForumGroup",
      entityName:"Content",
      formLocation:"component://content/widget/forum/ForumForms.xml",
      fields:this.getFields("AddForumGroup",FORMS),
      targets:this.getTargets("AddForumGroup",FORMS)
    }),
    findForm:new OfbizForm({
      local:true,
      viewMode:"popover",
      formAction:"find",
      formName:"FindContent",
      entityName:"Content",
      formLocation:"component://content/widget/content/ContentForms.xml",
      target:"listFindContent",
      fields:this.getFields("FindContent",FORMS),
    }),
    actions:[],
    settings:[],
    breadCrumbData:{
      displayPrefix:"Forum Groups",
      label:"",
      labelFieldName:"contentName",
      level:1,
      selectedValue:{
          "event":"list",
          "type":"ListForumGroups",
          "data":{
            "formData":{
              "formName":"ListForumGroupsRest",
              "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
              "viewIndex":1
            },
            "endPoint":"listFindContent",
          },
      },
      addFormText:"Create New Forum Group",
      editFormText:"Update Forum Group",
    },
    childComponent:new ComponentConfig({
      name:"Forums",
      title:"Forums",
      idFieldName:"contentId",
      lookUpEndPoint:"LookupContent",
      searchResults:null,
      listForm:new OfbizList({
        //fieldFormFields:this.getFields("FindBlogContent",FORMS),
        listFormName:"ListForumsRest",
        entityName:"ContentAssocViewTo",
        listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
        endPoint:"listFindBlogContent",
        viewIndex:1,
        columnFields:this.getFields("ListForumsRest",FORMS),
        labelColumn:"contentName",
        emptyListMessage:"",
      }),
      addForm:new OfbizForm({
        'local':true,
        "formName":"AddForumRest",
        "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
        fields:this.getFields("AddForumRest",FORMS),
        targets:this.getTargets("AddForumRest",FORMS)
      }),
      findForm:new OfbizForm({

      }),
      actions:[],
      breadCrumbData:{
        displayPrefix:"Forums for ",
        labelFieldName:"",
        label:"",
        level:2,
        selectedValue:{
            "event":"list",
            "type":"ListForums",
            "data":{
              formData:{
                "formName":"ListForumsRest",
                "formLocation":"component://content/widget/forum/ForumForms.xml",
                "viewIndex":1
              },
              "endPoint":"listFindContent",
            },
        },
        addFormText:"Create New Forum",
        editFormText:"Update Forum",
      },
      childComponent:new ComponentConfig({
        name:"Messages",
        title:"Messages",
        idFieldName:"contentId",
        lookUpEndPoint:"LookupContent",
        searchResults:null,
        listForm:new OfbizList({
          //fieldFormFields:this.getFields("FindBlogContent",FORMS),
          listFormName:"ListForumMessagesRest",
          entityName:"ContentAssocViewTo",
          listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          endPoint:"listFindBlogContent",
          viewIndex:1,
          columnFields:this.getFields("ListForumMessagesRest",FORMS),
          emptyListMessage:"",
        }),
        addForm:new OfbizForm({
          "local":true,
          "formName":"AddForumMessageRest",
          "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
          fields:this.getFields("AddForumMessageRest",FORMS),
          targets:this.getTargets("AddForumMessageRest",FORMS)
        }),
        findForm:new OfbizForm({

        }),
        actions:[],
      breadCrumbData:{
        displayPrefix:"Messages",
        labelFieldName:"",
        label:"",
        level:3,
        selectedValue:{
            "event":"list",
            "type":"ListForumMessagesRest",
            "data":{
              formData:{
                "formName":"ListForumMessagesRest",
                "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
                "viewIndex":1
              },
              "endPoint":"listFindContent",
            },
          },
          addFormText:"Create New Message",
          editFormText:"Update Message",
        },
      })
    })
  }
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
  }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

}
